// @core/api/endpoints/subscription/get_add_on.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddOnResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get addon details
 * Retrieves addon details including pricing, features, and compatibility.
 * @public This endpoint does not require authentication
 */
export async function GetAddOn(
  addon_id: string,
  options?: RequestOptions
): Promise<AddOnResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/addons/:addon_id`;
  requestPath = requestPath.replace(':addon_id', encodeURIComponent(addon_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<AddOnResponse>(requestPath, { ...requestOptions });
}
